module.exports = __webpack_public_path__ + "static/img/u45m.4e72775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/u45m.png
// module id = zHLu
// module chunks = 8